<template>
    <div class="page-scan-in">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">同城配送</div>
            <div class="breadcrumb-item">同城批量詳情 修改</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="12">
                        <Form :label-width="180">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>收件人手機號/會員號</span>
                                </div>
                                <Input v-model="form.recipient_phone" @on-blur="getPickAddressByPhone" style="border: 2px solid;border-radius: 5px;"></Input>
                                <span style="color:red">若已註冊集運幫輸入可獲得會員名稱、提貨櫃點和收件方式</span>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>收件人</span>
                                </div>
                                <Input v-model="form.recipient_contacts" style="border: 2px solid;border-radius: 5px;"></Input>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>提貨櫃點</span>
                                </div>

                                <Select placeholder="請選擇" not-found-text="無匹配數據" filterable v-model="form.arrive"
                                        @on-change="handleArriveSelect" style="border: 2px solid;border-radius: 5px;">
                                    <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                                            :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                                    </Option>
                                </Select>
                            </FormItem>

                            <FormItem hidden>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>店/櫃</span>
                                </div>

                                <RadioGroup v-model="form.arrive_type">
                                    <Radio :disabled="arrive_type_status ? true : false" :label="1">
                                        <span>門店</span>
                                    </Radio>
                                    <Radio :disabled="arrive_type_status ? true : false" :label="2">
                                        <span>智能櫃</span>
                                    </Radio>
                                </RadioGroup>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>出貨單號</span>
                                </div>

                                <Input v-model="form.odd_numbers" @on-blur="getOdd" @keyup.enter.native="getOdd" placeholder="輸入出貨單號" style="border: 2px solid;border-radius: 5px;" :maxlength="15" disabled>
                                    <span slot="prepend">{{odd_numbers_array[0]}}_</span>
                                    <span slot="append">_{{odd_numbers_array[2]}}</span>
                                </Input>

                                <span style="color:red">{{odd_numbers_array[0]}}_{{form.odd_numbers}}_{{odd_numbers_array[2]}}</span>

                                <!-- <span style="color:red">XXXXXXX為隨機數字，主要是防止單號重覆的問題</span> -->
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>費用</span>
                                </div>
                                <RadioGroup v-model="form.type">
                                    <Radio :label="1">
                                        <span>收方支付</span>
                                    </Radio>
                                    <Radio :label="2" v-if="form.freight_collect == 0">
                                        <span>發方餘額</span>
                                    </Radio>
                                    <Radio :label="3" v-if="form.freight_collect == 0">
                                        <span>發方月結</span>
                                    </Radio>
                                </RadioGroup>

                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>重量</span>
                                </div>
                                <InputNumber :min="1" v-model="form.weight" placeholder="KG" style="border: 2px solid;border-radius: 5px;"></InputNumber>
                                &nbsp;
                                <span style="color:red">請輸入整數</span>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <span>代收金額（選填）</span>
                                </div>
                                <InputNumber :min="0" v-model="form.freight_collect" placeholder="MOP費用" style="border: 2px solid;border-radius: 5px;"></InputNumber>&nbsp;
                                <span style="color:red">為空就代表不用
                                出客戶到付費用</span>
                            </FormItem>              
                        </Form>
                    </Col>

                    <Col span="10" offset="1">
                        <Form :label-width="160">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <span>寄件人名稱（選填）</span>
                                </div>
                                <Input v-model="form.courier" style="border: 2px solid;border-radius: 5px;"></Input>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <span>寄件人電話（選填）</span>
                                </div>
                                <Input v-model="form.courier_tel" type="number" :min="0" style="border: 2px solid;border-radius: 5px;"></Input>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <span>備註（選填）</span>
                                </div>
                                <Input :maxlength="50" type="textarea" v-model="form.remarks" placeholder="最多輸入50個字" style="border: 2px solid;border-radius: 5px;"></Input>
                            </FormItem>

                            <FormItem>
                                <span style="color:red;font-size: 26px;">商家餘額：{{sc_balance}}</span>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
                <Row type="flex" justify="center">
                    <Col>
                        <Form>
                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                    <div class="pg-btn style2" @click="handlePrintCode">打印面單</div>
                                    <div class="pg-btn style1" @click="handleCheckForm">修改</div>
                                </div>
                            </FormItem> 
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
        <!-- <iframe style="display:none" id="printIframe" src="<%=data%>"></iframe>-->
        <iframe id="printIframe" style="display:none" :src="pdfUrl"></iframe>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                deliverListAll: [], //所有快件明細
                deliverList: [],    //快件明細，截取
                pickAddress: [],    //提貨櫃點
                packageType: [],    //包裹類型
                deliverExc: [], //異常件
                odd_numbers_array: [],
                odd_numbers_string: '',
                err_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-fail.mp3",
                suc_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-success.mp3",
                isLoadingDeliver: false,
                arrive_type_status: false,
                form: {
                    weight: 1,  //重量單位g
                    type: '',
                    odd_numbers: '',  //單號
                    recipient_phone: '',  //澳門手機號
                    detailed: 3648,    //快件明細id
                    recipient_contacts: '',  //澳門客戶名稱
                    arrive: '', //提貨櫃點
                    goods_type: 2,  //包裹類型id
                    arrive_type: '',   //收件方式: 1門店，2:智能櫃
                    abnormal_id: '', //異常id
                    freight_collect: '', //珠海到付運費
                    count: 1,   //數量
                    courier: '',
                    courier_tel: '',
                    remarks: '',
                },
                isSubmiting: false,
                pdfUrl: '',
                sc_name: '',
                sc_id: '',
                sc_user_id: '',
                sc_store_id: '',
                sc_balance: '',
                current_time: ''
            };
        },
        created(){
            this.isSubmiting = true;
            this.getPickAddress();
        },
        mounted()
        {
            this.pageParam = this.$route.query;
            var data = new Date();
            var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
            var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
            this.current_time = data.getFullYear() + "" + month + "" + date;

            let logInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
            let token = localStorage.getItem('jyb_token') || '';
            const state = {
                logInfo,
                token
            };
            if(state.logInfo.userparent != null){
                this.sc_name = state.logInfo.userparent.mark;
                this.sc_id = state.logInfo.userparent.id;
                this.sc_balance = state.logInfo.userparent.balance;
                this.sc_user_id = state.logInfo.user_id;
                this.sc_store_id = state.logInfo.store_id;
            }

            this.getDetail();
        },
        methods: {
            handleBack() {
                this.$router.go(-1);
            },
            getOdd() {
                if(this.odd_numbers == '') {
                    return false;
                }
                this.getItem();
                // this.getDetail();
            },
            getDetail() {
                this.$Rq.requestAuth({
                    url: this.$Api.deliverDetail + '/' + this.pageParam.id,
                    method: 'get'
                }).then((res) => {
                    if (res.code == 0) {
                        this.isSubmiting = false;
                        let resData = res.data;
                        var odd_numbers_string = resData.odd_numbers;
                        this.odd_numbers_string = odd_numbers_string;
                        if(odd_numbers_string.includes('_')){
                            let odd_numbers_array = odd_numbers_string.split('_');
                            this.odd_numbers_array = odd_numbers_array;
                            resData.odd_numbers = odd_numbers_array[1];
                        }
                        this.form = {
                            amount: resData.amount,
                            weight: resData.weight,
                            sack_number :resData.sack_number,
                            odd_numbers: resData.odd_numbers,
                            recipient_phone: resData.recipient_phone,
                            long: resData.long,
                            wide: resData.wide,
                            height: resData.height,
                            size: resData.size,
                            detailed: resData.detailed.id,
                            instructions: resData.instructions,
                            recipient_contacts: resData.recipient_contacts,
                            arrive: resData.arrive,
                            goods_type: resData.goods_type,
                            arrive_type: resData.arrive_type,
                            abnormal_id: resData.abnormal_id,
                            type: resData.type,
                            freight_collect: Number(resData.freight_collect),
                            count: resData.count,
                            courier: resData.courier,
                            courier_tel: Number(resData.courier_tel),
                            remarks: resData.remarks,
                        }
                    }
                });
            },
            getItem() 
            {
                this.$Rq.requestAuth({
                    url: this.$Api.scanIn,
                    method: 'get',
                    data: {
                        sack_number: this.odd_numbers_array[0] + '_' + this.form.odd_numbers + '_' + this.odd_numbers_array[2],
                        odd_numbers: this.odd_numbers_array[0] + '_' + this.form.odd_numbers + '_' + this.odd_numbers_array[2],
                    }
                }).then((res) => {
                    if(res.data.count == 1) {
                        this.$Utils.showTipInfo('該單號已存在');
                        let audio = new Audio()
                        audio.src = this.err_audio
                        audio.play();
                    }
                })
            },
            //提貨櫃點
            getPickAddress()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 1,
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAddress = res.data.data;
                    }
                });
            },
            //根據手機號獲取提貨櫃點,以及客戶名稱
            getPickAddressByPhone()
            {
                let form = this.form;
                if (form.recipient_phone !== '') {
                    this.$Rq.requestAuth({
                        url: this.$Api.getInfoByPhone + "/" + form.recipient_phone,
                        method: 'get',
                    }).then((res) => {
                        if (res.code == 0) {
                            if(res.data.length==0) {
                                this.$Utils.showTipInfo('用戶不存在');
                                // return false;
                            } else {
                                let resData = res.data || {};
                                this.form.recipient_contacts = resData.user_id ? resData.user_name : '';
                                this.form.recipient_phone = resData.user_id ? resData.phone : ''; // 會員號碼 match 電話號碼
                                this.form.arrive = resData.receiving ? resData.receiving.ReceivingID : '';
                                this.form.arrive_type = resData.receiving ? resData.receiving.Type : '';    //type 1门店， 2是智能柜    
                            }
                            
                        }
                    });
                } else {
                    this.form.recipient_contacts = '';
                    this.form.arrive = '';
                }
            },
            //提貨櫃點選擇
            handleArriveSelect(value)
            {
                if (value == undefined) {
                    this.arrive_type_status = false;
                    return;
                }
                let pickAddress = this.pickAddress;
                let index = null;
                for (let i = 0; i < pickAddress.length; i++)
                {
                    if (value == pickAddress[i].ReceivingID)
                    {
                        index = i;
                        break;
                    }
                }
                this.arrive_type_status = true;
                this.form.arrive_type = pickAddress[index].Type;    //Type 1門店, 2智能櫃
            },
            handleCheckForm()
            {
                let form = this.form;
                if (form.weight == '')
                {
                    this.$Utils.showTipInfo('請輸入重量');
                    return;
                }
                if (form.odd_numbers == '')
                {
                    this.$Utils.showTipInfo('請輸入快遞單號');
                    return;
                }
                if (form.type == '')
                {
                    this.$Utils.showTipInfo('請選擇快遞類型');
                    return;
                } 
                if (form.type > 1 && form.freight_collect > 0)
                {
                    this.$Utils.showTipInfo('請選擇快遞類型');
                    return;
                } 
                if (!(form.detailed > 0))
                {
                    this.$Utils.showTipInfo('請選擇快件明細');
                    return;
                }
                if (form.recipient_phone == '')
                {
                    this.$Utils.showTipInfo('請輸入澳門手機號或會員號碼');
                    return;
                }               
                if (form.recipient_contacts == '')
                {
                    this.$Utils.showTipInfo('請輸入客戶名稱');
                    return;
                }
                if (form.arrive == '')
                {
                    this.$Utils.showTipInfo('請選擇提貨櫃點');
                    return;
                }
                if (form.arrive_type == '')
                {
                    this.$Utils.showTipInfo('請選擇收件方式');
                    return;
                }

                this.handleSubmit();
                // this.$refs.command_id.focus();
            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.samecityDetailEdit + '/' + this.pageParam.id,
                    method: 'get',
                    data: {
                        parent_id: Number(this.sc_id),
                        arrive: Number(form.arrive),
                        type: Number(form.type),
                        courier: form.courier,
                        courier_tel: Number(form.courier_tel),
                        recipient_phone: form.recipient_phone,
                        recipient_contacts: form.recipient_contacts,
                        weight: Number(form.weight),
                        freight_collect: Number(form.freight_collect) ? Number(form.freight_collect) : 0,
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        if(res.msg == "修改成功") {
                            let audio = new Audio()
                            audio.src = this.suc_audio
                            audio.play();
                        } else {
                            let audio = new Audio()
                            audio.src = this.err_audio
                            audio.play();
                        }
                        this.$Utils.showSuccess(res.msg);
                        this.deliverList = this.deliverListAll.slice(0, 240);
                    } else {
                        let audio = new Audio()
                        audio.src = this.err_audio
                        audio.play();
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    let audio = new Audio()
                    audio.src = this.err_audio
                    audio.play();
                    this.isSubmiting = false;
                });
            },
            handlePrintCode()
            {
                let form = this.form;
                if (form.weight == '')
                {
                    this.$Utils.showTipInfo('請輸入重量');
                    return;
                }
                if (form.odd_numbers == '')
                {
                    this.$Utils.showTipInfo('請輸入快遞單號');
                    return;
                }
                if (form.type == '')
                {
                    this.$Utils.showTipInfo('請選擇快遞類型');
                    return;
                } 
                if (form.type > 1 && form.freight_collect > 0)
                {
                    this.$Utils.showTipInfo('請選擇快遞類型');
                    return;
                } 
                if (!(form.detailed > 0))
                {
                    this.$Utils.showTipInfo('請選擇快件明細');
                    return;
                }
                if (form.recipient_phone == '')
                {
                    this.$Utils.showTipInfo('請輸入澳門手機號或會員號碼');
                    return;
                }               
                if (form.recipient_contacts == '')
                {
                    this.$Utils.showTipInfo('請輸入客戶名稱');
                    return;
                }
                if (form.arrive == '')
                {
                    this.$Utils.showTipInfo('請選擇提貨櫃點');
                    return;
                }
                if (form.arrive_type == '')
                {
                    this.$Utils.showTipInfo('請選擇收件方式');
                    return;
                }
                let token = localStorage.getItem('jyb_token');
                let params = {
                    //Authorization: token,
                    type: form.type,
                    arrive: form.arrive,
                    weight: form.weight,
                    courier: form.courier,
                    courier_tel: form.courier_tel,
                    odd_numbers: this.odd_numbers_array[0] + '_' + form.odd_numbers + '_' + this.odd_numbers_array[2],
                    recipient_contacts: form.recipient_contacts,
                    recipient_phone: form.recipient_phone,
                    freight_collect: Number(form.freight_collect) ? Number(form.freight_collect): 0,
                    parent_id: this.sc_id,
                    store_id: this.sc_store_id,
                    user_id: this.sc_user_id,
                    remarks: form.remarks,
                };
                this.pdfUrl = this.$Api.samecityorderprint + '?' + this.$Utils.formateObjToParamStr(params);
                window.open(this.pdfUrl);
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "samecityMultiScaninEdit.scss";
</style>